/* eslint-disable */
/* eslint-disable no-alert */
import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import { AlertAdapter, CommonDatePicker, CommonDropdown, CommonInput, DatePicker, RegularButton } from 'pg-ui-library';
import {
  BeneficiariesInputContainer,
  BeneficiariesInputError,
  CreateBenificiariesContainer,
  CreateBenificiariesContainerSave,
  CreateBenificiariesFirstRow,
  CreateBenificiariesSecondRow,
  CreateBenificiariesThirdRow,
  CustomDatePicker,
} from './styles';
import { ErrorMessage, useFormik } from 'formik';
import BenefitsService from 'src/services/benefits.service';
import { useTranslation } from 'react-i18next';
import { phoneRegExp } from 'src/utils/phoneRegex';
import { useActions } from 'src/hooks/useActions';

export const CreateBeneficiaries: React.FC<{
  benefitId: string;
  setCreateBeneficiary: any;
  handleBeneficiariesModal?: any;
}> = ({ benefitId, setCreateBeneficiary, handleBeneficiariesModal }) => {
  const now = new Date();
  const { t } = useTranslation();
  const { getPersonalInfo } = useActions();
  const [dropdownRelationshipOptions, setDropdownOptions] = useState<any[]>([
    {
      key: 'N/A',
      label: 'N/A',
      value: 'N/A',
    },
    {
      key: 'Husband',
      label: 'Husband',
      value: 'husband',
    },
    {
      key: 'Son',
      label: 'Son',
      value: 'son',
    },
    {
      key: 'Wife',
      label: 'Wife',
      value: 'wife',
    },
    {
      key: 'Daughter',
      label: 'Daughter',
      value: 'daughter',
    },
  ]);
  const [dropdownGenderOptions, setDropdownGenderOptions] = useState<any[]>([
    {
      key: 'N/A',
      label: 'N/A',
      value: 'N/A',
    },
    {
      key: 'Male',
      label: 'Male',
      value: 'male',
    },
    {
      key: 'Female',
      label: 'Female',
      value: 'female',
    },
  ]);

  const [dropdownSmokerOptions, setDropdownSmokerOptions] = useState<any[]>([
    {
      key: 'Yes',
      label: 'Yes',
      value: true,
    },
    {
      key: 'No',
      label: 'No',
      value: false,
    },
  ]);
  const [dropdownStudentOptions, setDropdownStudetOptions] = useState<any[]>([
    {
      key: 'Yes',
      label: 'Yes',
      value: true,
    },
    {
      key: 'No',
      label: 'No',
      value: false,
    },
  ]);

  const validationSchema = yup.object().shape({
    firstName: yup.string().min(1, 'Too small').max(30, 'Too large').required(t('global.form.required')),
    middleName: yup.string().min(1, 'Too small').max(30, 'Too large').required(t('global.form.required')),
    lastName: yup.string().min(1, 'Too small').max(30, 'Too large').required(t('global.form.required')),
    relationship: yup.string().required(t('global.form.required')),
    ssn: yup.string().min(1, 'Too small').max(30, 'Too large'),
    address: yup.string().min(1, 'Too small').max(255, 'Too large'),
    city: yup.string().min(1, 'Too small').max(255, 'Too large'),
    state: yup.string().min(1, 'Too small').max(255, 'Too large'),
    zipCode: yup.string().min(1, 'Too small').max(20, 'Too large'),
    email: yup.string().min(1, 'Too small').max(30, 'Too large').email('Invalid email'),
    county: yup.string().min(1, 'Too small').max(30, 'Too large'),
    country: yup.string().min(1, 'Too small').max(30, 'Too large'),
    gender: yup.string(),
    homePhone: yup
      .string()
      .min(1, 'Too small')
      .max(30, 'Too large')
      .matches(phoneRegExp, t('global.form.invalidPhone')),
    workPhone: yup
      .string()
      .min(1, 'Too small')
      .max(30, 'Too large')
      .matches(phoneRegExp, t('global.form.invalidPhone')),
    smoker: yup.string(),
    student: yup.string(),
  });

  const formik = useFormik<any>({
    initialValues: {
      firstName: '',
      middleName: '',
      lastName: '',
      relationship: '',
      ssn: '',
      address: '',
      birthDate: '',
      city: '',
      state: '',
      zipCode: '',
      county: '',
      country: '',
      gender: '',
      homePhone: '',
      workPhone: '',
      smoker: '',
      student: '',
      email: '',
      benefitId: benefitId,
    },
    validationSchema,
    onSubmit: async values => {
      const response = await BenefitsService.createBeneficiary(values);
      AlertAdapter('Beneficiary created successfully!', 'success');
      if (response.status === 200) {
        AlertAdapter('Beneficiary created successfully!', 'success');
        setCreateBeneficiary(false);
      }
    },
  });
  return (
    <>
      <CreateBenificiariesContainer>
        <CreateBenificiariesFirstRow>
          <BeneficiariesInputContainer>
            <CommonInput
              label="First Name*"
              onChange={event => formik.setFieldValue('firstName', event.target.value)}
              style={{ border: '1px black solid', width: '180px', marginRight: '10px' }}
            />
            <BeneficiariesInputError>{formik.errors.firstName}</BeneficiariesInputError>
          </BeneficiariesInputContainer>
          <BeneficiariesInputContainer>
            <CommonInput
              label="Middle Name*"
              onChange={event => formik.setFieldValue('middleName', event.target.value)}
              style={{ border: '1px black solid', width: '180px', marginRight: '19px' }}
            />
            <BeneficiariesInputError>{formik.errors.middleName}</BeneficiariesInputError>
          </BeneficiariesInputContainer>

          <BeneficiariesInputContainer>
            <CommonInput
              label="Last Name*"
              onChange={event => formik.setFieldValue('lastName', event.target.value)}
              style={{ border: '1px black solid', width: '180px', marginRight: '19px' }}
            />
            <BeneficiariesInputError>{formik.errors.lastName}</BeneficiariesInputError>
          </BeneficiariesInputContainer>
          <BeneficiariesInputContainer>
            <CommonDropdown
              label="Relationship*"
              id="relationship"
              name="relationship"
              options={dropdownRelationshipOptions}
              wrapperStyle={{ width: '100%' }}
              selectStyle={{
                marginLeft: '0px',
                marginTop: '2%',
                marginRight: '20px',
                border: '0.3px black solid',
                minWidth: '178px',
                maxWidth: '178px',
              }}
              setValue={(value: any) => formik.setFieldValue('relationship', value)}
            />
            <BeneficiariesInputError>{formik.errors.relationship}</BeneficiariesInputError>
          </BeneficiariesInputContainer>
          <BeneficiariesInputContainer>
            <CommonInput
              label="SSN"
              onChange={event => formik.setFieldValue('ssn', event.target.value)}
              style={{ border: '1px black solid', width: '180px', marginRight: '10px', marginLeft: '0px' }}
            />
            <BeneficiariesInputError>{formik.errors.ssn}</BeneficiariesInputError>
          </BeneficiariesInputContainer>
          <BeneficiariesInputContainer>
            <CommonInput
              label="Address"
              onChange={event => formik.setFieldValue('address', event.target.value)}
              style={{ border: '1px black solid', width: '191px', marginLeft: '9px', marginRight: '10px' }}
            />
            <BeneficiariesInputError>{formik.errors.address}</BeneficiariesInputError>
          </BeneficiariesInputContainer>
        </CreateBenificiariesFirstRow>
        <CreateBenificiariesSecondRow>
          <BeneficiariesInputContainer>
            <CustomDatePicker
              maxDate={now}
              id="birthDate"
              name="birthDate"
              value={formik.values.birthDate}
              label="Birth Date"
              dateFormat="MM/dd/yyyy"
              onChange={(val: Date) => {
                formik.setFieldValue('birthDate', val.toLocaleDateString());
              }}
            />
            <BeneficiariesInputError>{formik.errors.birthDate}</BeneficiariesInputError>
          </BeneficiariesInputContainer>
          <BeneficiariesInputContainer>
            <CommonInput
              label="City"
              onChange={event => formik.setFieldValue('city', event.target.value)}
              style={{ border: '1px black solid', width: '180px', marginRight: '10px' }}
            />
            <BeneficiariesInputError>{formik.errors.city}</BeneficiariesInputError>
          </BeneficiariesInputContainer>
          <BeneficiariesInputContainer>
            <CommonInput
              label="State"
              onChange={event => formik.setFieldValue('state', event.target.value)}
              style={{ border: '1px black solid', width: '180px', marginRight: '10px' }}
            />
            <BeneficiariesInputError>{formik.errors.state}</BeneficiariesInputError>
          </BeneficiariesInputContainer>
          <BeneficiariesInputContainer>
            <CommonInput
              label="Zip Code"
              onChange={event => formik.setFieldValue('zipCode', event.target.value)}
              style={{ border: '1px black solid', width: '180px', marginRight: '10px' }}
            />
            <BeneficiariesInputError>{formik.errors.zipCode}</BeneficiariesInputError>
          </BeneficiariesInputContainer>
          <BeneficiariesInputContainer>
            <CommonInput
              label="County"
              onChange={event => formik.setFieldValue('county', event.target.value)}
              style={{ border: '1px black solid', width: '180px', marginRight: '10px' }}
            />
            <BeneficiariesInputError>{formik.errors.county}</BeneficiariesInputError>
          </BeneficiariesInputContainer>
          <BeneficiariesInputContainer>
            <CommonInput
              label="Country"
              onChange={event => formik.setFieldValue('country', event.target.value)}
              style={{ border: '1px black solid' }}
            />
            <BeneficiariesInputError>{formik.errors.country}</BeneficiariesInputError>
          </BeneficiariesInputContainer>
        </CreateBenificiariesSecondRow>
        <CreateBenificiariesThirdRow>
          <BeneficiariesInputContainer>
            <CommonDropdown
              label="Gender"
              id="gender"
              name="gender"
              options={dropdownGenderOptions}
              wrapperStyle={{ width: '100%' }}
              selectStyle={{
                marginLeft: '3px',
                marginTop: '2%',
                border: '0.3px black solid',
                minWidth: '178px',
                maxWidth: '178px',
              }}
              setValue={(value: any) => formik.setFieldValue('gender', value)}
            />
            <BeneficiariesInputError>{formik.errors.gender}</BeneficiariesInputError>
          </BeneficiariesInputContainer>
          <BeneficiariesInputContainer>
            <CommonInput
              label="Home Phone"
              onChange={event => formik.setFieldValue('homePhone', event.target.value)}
              style={{ border: '1px black solid', width: '180px', marginLeft: '5px', marginRight: '4px' }}
            />
            <BeneficiariesInputError>{formik.errors.homePhone}</BeneficiariesInputError>
          </BeneficiariesInputContainer>
          <BeneficiariesInputContainer>
            <CommonInput
              label="Work Phone"
              onChange={event => formik.setFieldValue('workPhone', event.target.value)}
              style={{ border: '1px black solid', width: '180px', marginRight: '0px', marginLeft: '-8px' }}
            />
            <BeneficiariesInputError>{formik.errors.workPhone}</BeneficiariesInputError>
          </BeneficiariesInputContainer>
          <BeneficiariesInputContainer>
            <CommonDropdown
              label="Smoker"
              id="smoker"
              name="smoker"
              options={dropdownSmokerOptions}
              wrapperStyle={{ width: '100%' }}
              selectStyle={{
                minWidth: '181px',
                marginLeft: '2%',
                marginTop: '2%',
                border: '0.3px black solid',
                width: '170px',
                marginRight: '10px',
              }}
              setValue={(value: any) => formik.setFieldValue('smoker', value)}
            />
            <BeneficiariesInputError>{formik.errors.smoker}</BeneficiariesInputError>
          </BeneficiariesInputContainer>
          <BeneficiariesInputContainer>
            <CommonDropdown
              label="Student"
              id="student"
              name="student"
              options={dropdownStudentOptions}
              wrapperStyle={{ width: '100%' }}
              selectStyle={{
                minWidth: '175px',
                marginLeft: '-2%',
                marginTop: '2%',
                border: '0.3px black solid',
              }}
              setValue={(value: any) => formik.setFieldValue('student', value)}
            />
            <BeneficiariesInputError>{formik.errors.student}</BeneficiariesInputError>
          </BeneficiariesInputContainer>
          <BeneficiariesInputContainer>
            <CommonInput
              label="Email"
              onChange={event => formik.setFieldValue('email', event.target.value)}
              style={{ border: '1px black solid', width: '190px', marginRight: '10px' }}
            />
            <BeneficiariesInputError>{formik.errors.email}</BeneficiariesInputError>
          </BeneficiariesInputContainer>
        </CreateBenificiariesThirdRow>
        <CreateBenificiariesContainerSave>
          <RegularButton onClick={() => handleBeneficiariesModal(false)}>Cancel</RegularButton>
          <RegularButton
            disabled={!formik.isValid || formik.isSubmitting}
            onClick={() => formik.submitForm().then(() => setCreateBeneficiary(false))}
          >
            Save
          </RegularButton>
        </CreateBenificiariesContainerSave>
      </CreateBenificiariesContainer>
    </>
  );
};
